module.exports = require('./$.global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// ./~/redux-api-middleware-fixed/~/core-js/library/modules/$.html.js
// module id = O+hZ
// module chunks = 23